export default __webpack_public_path__ + "static/media/safeFamilyJustice.0ef41bc5.png";